/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  FundEntityCreateDataRequest
} from '../../model/fundEntityCreateDataRequest'
import type {
  FundEntityEditDataRequest
} from '../../model/fundEntityEditDataRequest'
import type {
  FundEntityReadData
} from '../../model/fundEntityReadData'
import type {
  FundEntityReadDataList
} from '../../model/fundEntityReadDataList'
import type {
  FundListParams
} from '../../model/fundListParams'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Get a list of Fund Entities
 */
export const fundList = (
    params?: FundListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundEntityReadDataList>(
      {url: `/fund-entities/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFundListQueryKey = (params?: FundListParams,) => {
    return [`/fund-entities/`, ...(params ? [params]: [])] as const;
    }

    
export const getFundListQueryOptions = <TData = Awaited<ReturnType<typeof fundList>>, TError = unknown>(params?: FundListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundList>>> = ({ signal }) => fundList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundList>>, TError, TData> & { queryKey: QueryKey }
}

export type FundListQueryResult = NonNullable<Awaited<ReturnType<typeof fundList>>>
export type FundListQueryError = unknown

export const useFundList = <TData = Awaited<ReturnType<typeof fundList>>, TError = unknown>(
 params?: FundListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundList>>, TError = unknown>(params?: FundListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundList>>> = ({ signal }) => fundList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundList>>, TError, TData> & { queryKey: QueryKey }
}

export type FundListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundList>>>
export type FundListSuspenseQueryError = unknown

export const useFundListSuspense = <TData = Awaited<ReturnType<typeof fundList>>, TError = unknown>(
 params?: FundListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundListLoader = (queryParamsOrFn?: (FundListParams | ((params: Params) => FundListParams))): LoaderFunction =>
        authedLoader(({ params }) => {
          const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          return appQueryClient.prefetchQuery({
            queryKey: getFundListQueryKey(queryParams),
            queryFn: () => fundList(queryParams),
          }).then(() => null);
        });
      /**
 * Create a new Fund Entity
 */
export const fundCreate = (
    fundEntityCreateDataRequest: FundEntityCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundEntityReadData>(
      {url: `/fund-entities/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fundEntityCreateDataRequest
    },
      options);
    }
  


export const getFundCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundCreate>>, TError,{data: FundEntityCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundCreate>>, TError,{data: FundEntityCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundCreate>>, {data: FundEntityCreateDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  fundCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundCreateMutationResult = NonNullable<Awaited<ReturnType<typeof fundCreate>>>
    export type FundCreateMutationBody = FundEntityCreateDataRequest
    export type FundCreateMutationError = unknown

    export const useFundCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundCreate>>, TError,{data: FundEntityCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get a specific Fund Entity
 */
export const fundRetrieve = (
    fundFamilyId: string,
    id: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FundEntityReadData>(
      {url: `/fund-family/${fundFamilyId}/fund-entities/${id}/`, method: 'GET', signal
    },
      options);
    }
  

export const getFundRetrieveQueryKey = (fundFamilyId: string,
    id: string,) => {
    return [`/fund-family/${fundFamilyId}/fund-entities/${id}/`] as const;
    }

    
export const getFundRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof fundRetrieve>>, TError = unknown>(fundFamilyId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundRetrieveQueryKey(fundFamilyId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundRetrieve>>> = ({ signal }) => fundRetrieve(fundFamilyId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fundRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof fundRetrieve>>>
export type FundRetrieveQueryError = unknown

export const useFundRetrieve = <TData = Awaited<ReturnType<typeof fundRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fundRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundRetrieveQueryOptions(fundFamilyId,id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFundRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof fundRetrieve>>, TError = unknown>(fundFamilyId: string,
    id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFundRetrieveQueryKey(fundFamilyId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fundRetrieve>>> = ({ signal }) => fundRetrieve(fundFamilyId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && id), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FundRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof fundRetrieve>>>
export type FundRetrieveSuspenseQueryError = unknown

export const useFundRetrieveSuspense = <TData = Awaited<ReturnType<typeof fundRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof fundRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFundRetrieveSuspenseQueryOptions(fundFamilyId,id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFundRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,id: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,id } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && id) {
            return appQueryClient.prefetchQuery({
              queryKey: getFundRetrieveQueryKey(fundFamilyId,id),
              queryFn: () => fundRetrieve(fundFamilyId,id),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Update a specific Fund Entity
 */
export const fundUpdate = (
    fundFamilyId: string,
    id: string,
    fundEntityEditDataRequest: FundEntityEditDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundEntityReadData>(
      {url: `/fund-family/${fundFamilyId}/fund-entities/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fundEntityEditDataRequest
    },
      options);
    }
  


export const getFundUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundUpdate>>, TError,{fundFamilyId: string;id: string;data: FundEntityEditDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundUpdate>>, TError,{fundFamilyId: string;id: string;data: FundEntityEditDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundUpdate>>, {fundFamilyId: string;id: string;data: FundEntityEditDataRequest}> = (props) => {
          const {fundFamilyId,id,data} = props ?? {};

          return  fundUpdate(fundFamilyId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof fundUpdate>>>
    export type FundUpdateMutationBody = FundEntityEditDataRequest
    export type FundUpdateMutationError = unknown

    export const useFundUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundUpdate>>, TError,{fundFamilyId: string;id: string;data: FundEntityEditDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Delete a specific Fund Entity
 */
export const fundDestroy = (
    fundFamilyId: string,
    id: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fund-entities/${id}/`, method: 'DELETE'
    },
      options);
    }
  


export const getFundDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundDestroy>>, TError,{fundFamilyId: string;id: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundDestroy>>, TError,{fundFamilyId: string;id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundDestroy>>, {fundFamilyId: string;id: string}> = (props) => {
          const {fundFamilyId,id} = props ?? {};

          return  fundDestroy(fundFamilyId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof fundDestroy>>>
    
    export type FundDestroyMutationError = unknown

    export const useFundDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundDestroy>>, TError,{fundFamilyId: string;id: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    